import { Component,Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DiscussionService } from '../../../shared-service/services/discussion.service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// import { FormBuilder, FormsModule } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-discuss-filter',
  templateUrl: './discuss-filter.component.html',
  styleUrls: ['./discuss-filter.component.css']
})
export class DiscussFilterComponent implements OnInit {

  @Input() pageTitle:string;
  @Output() valueChange = new EventEmitter();
  exams:any;
  subjects:any;
  examId:any;
  examRadio:any='';
  constructor(
    private discussionService: DiscussionService,
  ) { }

  ngOnInit() {
    $('.input-selected').click(function(){
      $(this).closest('.fiter-box').find('.input-options').toggleClass('d-none');
      $(this).closest('.fiter-box').find('.arrow-toggle').toggleClass('transform')
    })

    $("#input_subject").on("keyup", function() {
      var value = $(this).val().toLowerCase();
      $("#subject-type .option-list li").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
      });
    });
    $("#input_exam").on("keyup", function() {
      var value = $(this).val().toLowerCase();
      $("#exam-type .option-list li").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
      });
    });

    this.getExams();
    this.getSubjects();
  }

  onFormSubmit(form){
    this.examId = form.examRadio;
    this.valueChange.emit(this.examId);
    document.getElementById('exam-type').classList.add("d-none");
  }
  getExams(){
    this.discussionService.getExams().subscribe(
      (res:any) => {
        if(res.state === 200){
          this.exams = res.data;
        }
      }
    );
  }

  getSubjects(){
    this.discussionService.getSubjects().subscribe(
      (res:any) => {
        if(res.state === 200){
          this.subjects = res.data;
        }
      }
    );
  }


}
